/* eslint-disable max-len */
import PropTypes from 'prop-types'

/**
 * @typedef {Object} DriverTerminalMaps
 * @property {boolean} [active] - Indicates if the map is currently active on the driver terminal (= true) or not (= false)
 * @property {string} [name] - The name of the map installed on the driver terminal (PND)
 * @property {string} [version] - The version of the map installed on the driver terminal (PND)
 */
export const driverTerminalMapsPropType = PropTypes.shape({
    active: PropTypes.bool,
    name: PropTypes.string,
    version: PropTypes.string
})
